<template>
  <card :image="true" :footer="true" class="user-details">
    <template slot="image">
      <figure class="image is-5by1">
        <img :src="coverImage" alt="Profile Header" class="cover-profile">
        <button  class="button" @click="goBack" >
          <hv-image size="" :is-rounded="false" :src="favouriteStarUrl">
          </hv-image>
        </button>
      </figure>
    </template>
    <div class="media">
      <template>
        <div  class="media-content hirer p-10">
          <div class="title-text-container">
            <p class="date-text m-0">Posted {{date}}</p>
            <p  class="title is-4 m-0 title-text">Donate to Turkey</p>
            <p class="title is-4 m-0 title-text">Active </p>
          </div>
          <p class="is-cursor-pointer" >I propose we donate $1,000 on behalf of the HireVibes DAO to the victims of the recent Earthquake in Turkey</p>
          <p  class="m-t-8 mt-20">Amount Requested: 0 VIBES</p>
        </div>
      </template>
    </div>
    <template slot="footer">
    </template>
  </card>
</template>

<script>
import { mapGetters } from 'vuex'
import Card from '@/components/general/card'
import FavouriteStar from '@/assets/back-arrow.svg'
import HvImage from '@/components/general/image'
import moment from 'moment'

export default {
  components: { Card, HvImage },
  props: {

  },
  mounted () {
  },
  computed: {
    ...mapGetters('users', [
      'coverImageForUser',
      'userid'
    ]),
    favouriteStarUrl () {
      return FavouriteStar
    },
    isWidget () {
      return !!this.$route.meta.hasOwnProperty('widgetMode')
    },
    coverImage () {
      return this.coverImageUrl || this.coverImageForUser(this.user)
    },
    date () {
      return moment(new Date()).format('DD MMM YY')
    }
  },
  methods: {
    openCompanyUrl () {
      window.open(`https://www.${this.company.domain}`, '_blank')
    },
    goBack () {
      this.$router.go(-1)
    }
  },
  data () {
    return {
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/defaults.scss';

.user-details .card-content {
  background-color: black;
}

.card-footer p {
  padding: 1rem;
}

.card-footer p {
  padding: 1rem;
  text-align: center;
  width: 100%;
  color: #111;
}

.card-image figure {
  border-top-left-radius: 20px;
}

.card-content figure {
  margin-top: -4.5rem;
}

.card-content .media-content {
  text-align: center;
  margin-top: 16px;

  & .title {
    margin-bottom: 16px;
  }
}

.image.is-centered {
  position: relative;
  left: 50%;
  right: 50%;
  margin-left: -45px;
}

.image.is-circular {
  border: solid white 3px;
}

.image.is-5by1 {
  padding-top: 18.5%;

  .dropdown {
    float: right;
    margin-top: calc(-18.5% + 15px);
    margin-right: 15px;
  }

  .button {
    float: left;
    margin-top: calc(-18.5% + 15px);
    margin-left: 15px;
    font-weight: normal !important;
    text-transform: none;
  }

  .mr{
    margin-right: 10px;
  }

  & > img {
    height: 100%;
    width: 100%;
    position: absolute;
    bottom: 0;
    top: 0;
    left: 0;
    right: 0;
    border-top-left-radius: 0.25rem;
    border-top-right-radius: 0.25rem;
  }
}

.title-text-container{
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom:16px ;
}

.p-10{
  padding:0px 20px
}
.m-0{
  margin: 0px !important;
}

.date-text{
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
}

.mt-20{
  margin-top: 20px;
}

@media(max-width: 760px){
  .title-text-container{
    flex-direction: column;
    gap: 16px;
  }
.title-text{
  font-size: 20px;
}
  .p-10{
    padding:0
  }
}

</style>



// WEBPACK FOOTER //
// src/components/dao-community/proposal/header-card.vue